import '@/App.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ColorSchemeValueContext } from '@/context/colorSchemeContext';
import { AuthenticationGuard } from '@/Routing/AuthenticationGuard';
import createDashboardTheme from '@/styles/theme';

const CalizaCustomerDashboard: React.FC = (): React.ReactElement => {
  const colorScheme = React.useContext<'dark' | 'light'>(ColorSchemeValueContext);

  return (
    <ThemeProvider theme={createDashboardTheme(colorScheme)}>
      <CssBaseline />
      <Router>
        <AuthenticationGuard />
      </Router>
    </ThemeProvider>
  );
};

export default CalizaCustomerDashboard;
